module.exports = __webpack_public_path__ + "img/nav_icon_facial.763f1d02.svg";